/* This component dynamically loads an omniconvert script for A/B testing.
this script need to be mounted inside the head tag of each page. 
there is seperate script section written for thank you page to get event data
We use useEffect to ensure the script runs only once after the component mounts. */

'use client';
import { useEffect } from 'react';
import Head from 'next/head';

const OmniconvertLoader = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Check if the script is already added
      if (!document.querySelector('script[src="//cdn.omniconvert.com/js/pb80bb0.js"]')) {
        // Initialize the window._mktz array if not present
        window._mktz = window._mktz || [];

        // Dynamically inject the Omniconvert script
        const script = document.createElement('script');
        script.src = '//cdn.omniconvert.com/js/pb80bb0.js';
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }, []);

  return (
    <Head>
      {/* start Omniconvert code */}
      <link rel="dns-prefetch" href="//app.omniconvert.com" />
      {/* end Omniconvert code */}
    </Head>
  );
};

export default OmniconvertLoader;
